import { apiGet } from "./http";

export interface MemberAudienceStatsDto {
  totalMembers: number;
  activeMembers: number;
  newWithin30Days: number;
  unsignedCount: number;
  levelCounts: Record<string, number>;
}

export function fetchMemberAudienceStats(tenantLegacyId: string) {
  return apiGet<MemberAudienceStatsDto>(`/api/tenants/${tenantLegacyId}/member-audience-stats`);
}
